import { h, Fragment } from 'preact';

import CustomInput from './controls/custom-input';
import CustomFileInput from './controls/custom-file';
import CustomTextArea from './controls/custom-textarea';
import ControlCompleteName from './controls/full-name';
import CustomSelect from './controls/custom-select';
import AddressSelect from './controls/address';
import BankSelect from './controls/bank';
import CustomSelectNoFloat from './controls/custom-select-nofloat';
import CustomCheckbox from './controls/custom-checkbox';
import Birthdate from './controls/birthdate';
import CustomInputHidden from './controls/custom-input-hidden';
import { KycProps } from '../../constants/kyc';
import CustomAddressCheckbox from './controls/address-checkbox';
import CustomCheckboxRiskProfile from './controls/custom-checkbox-riskprofile';

type CustomFormProps = {
  controls: object[];
  children: any;
  onSubmit?: (e) => void;
  formRef?: any;
  isReview?: boolean;
};

const CustomForm = (props: CustomFormProps) => {
  return (
    <form onSubmit={props.onSubmit} ref={props.formRef}>
      <Controls controls={props.controls} isReview={props.isReview} />

      {props.children}
    </form>
  );
};

const Controls = props => {
  return (
    <>
      {props.controls.map(item => {
        if (item.tag == 'fullName') {
          return <ControlCompleteName key={item.id} controls={item.controls} />;
        } else if (item.tag == 'input') {
          return (
            <CustomInput
              key={item.id}
              placeholder={item.placeholder}
              name={item.name}
              type={item.type}
              label={item.label}
              validator={item.validator}
              value={item.value}
            />
          );
        } else if (item.tag == 'file') {
          return (
            <CustomFileInput
              key={item.id}
              placeholder={item.placeholder}
              name={item.name}
              label={item.label}
              validator={item.validator}
              preview={item.preview}
              isReview={props.isReview}
            />
          );
        } else if (item.tag == 'textarea') {
          return (
            <CustomTextArea
              key={item.id}
              placeholder={item.placeholder}
              name={item.name}
              type={item.type}
              label={item.label}
              validator={item.validator}
              value={item.value}
            />
          );
        } else if (item.tag == 'select') {
          return (
            <CustomSelect
              name={item.name}
              label={item.label}
              validator={item.validator}
              options={item.options}
              key={item.key}
              optionCategory={item.optionCategory}
              remoteOption={item.remoteOption}
              optionGetter={item.optionGetter}
              value={item.value}
            />
          );
        }
        // else if (item.tag == 'originTwo') {
        //   return <AddressSelectTwo key={item.key} controls={item.controls} />;
        // }
        else if (item.tag == 'origin') {
          // console.log(93, item.controls);
          return <AddressSelect key={item.key} controls={item.controls} />;
        } else if (item.tag == 'bank') {
          return <BankSelect key={item.key} controls={item.controls} />;
        } else if (item.tag == 'select-no-float') {
          return (
            <CustomSelectNoFloat
              name={item.name}
              label={item.label}
              validator={item.validator}
              options={item.options}
              value={item.value}
              key={item.key}
            />
          );
        } else if (item.tag == 'checkbox') {
          return (
            <CustomCheckbox
              name={item.name}
              label={item.label}
              options={item.options}
              key={item.key}
              value={item.value}
            />
          );
        } else if (item.tag == 'checkbox-riskprofile') {
          return (
            <CustomCheckboxRiskProfile
              name={item.name}
              label={item.label}
              options={item.options}
              key={item.key}
              value={item.value}
            />
          );
        } else if (item.tag == 'birthdate') {
          return (
            <Birthdate
              age={item.controls[KycProps.AGE]}
              birthdate={item.controls[KycProps.BIRTH_DATE]}
              key={item.key}
            />
          );
        } else if (item.tag == 'hidden') {
          return (
            <CustomInputHidden
              key={item.id}
              name={item.name}
              value={item.value}
            />
          );
        } else if (item.tag == 'address-checkbox') {
          return (
            <CustomAddressCheckbox
              name={item.name}
              label={item.label}
              options={item.options}
              key={item.key}
              value={item.value}
            />
          );
        }
      })}
    </>
  );
};

export default CustomForm;
